import { LessonStatus } from '../types/courseData';

/** Status de liberacao que a API devolve em report[].classes[].status */
export const API_LOCKED_STATUS: LessonStatus = 'LOCKED';

/** O minimo que o helper precisa de uma aula para decidir o bloqueio. */
export interface LockableLesson {
  status?: LessonStatus | null;
  principal?: boolean | null;
}

/**
 * A aula esta bloqueada para o aluno?
 *
 * A regra completa vive aqui, para os dois designs (legado e novo) nao
 * divergirem:
 *
 * 1. aula de curso adicional (`principal: false`) nunca bloqueia;
 * 2. entre as do curso principal, a UNICA fonte de verdade e o `status` da API.
 *
 * NAO deduzir o bloqueio pela data de `days[]`: desde a configuracao "Desbloquear
 * aula", uma aula pode exibir data futura e estar liberada. Comparar a data
 * com hoje -- como o app fazia -- volta a bloquear justamente as aulas que a
 * configuracao existe para liberar.
 *
 * `status` ausente conta como liberada (fail-open), o mesmo que o app ja fazia
 * para aulas sem `days` -- mas nunca em silencio: o cadeado e a unica barreira
 * do front, e o conteudo (video, PDF, texto) ja vem no payload da listagem.
 * `status` faltando e contrato quebrado da API e precisa aparecer no console --
 * `console.warn` direto, e nao `utils/logger`, porque este alerta tambem tem que
 * aparecer em producao, que e justamente onde uma quebra de contrato apareceria.
 *
 * @param lesson Aula de report[].classes[] ou de modules[].lessons[].
 */
export function isLessonLocked(lesson?: LockableLesson | null): boolean {
  if (!lesson?.principal) return false;

  if (!lesson.status) {
    console.warn(
      '[lessonLock] aula do curso principal sem `status` no payload da API -- liberando por fail-open',
      lesson,
    );

    return false;
  }

  return lesson.status === API_LOCKED_STATUS;
}
